/**
 * Matningskollen
 *
 * Skärdatan kommer från shop-metafältet verkstaden5.chiploads, som renderas i
 * sidan av sections/matningskollen.liquid. Metafältet skrivs av bygget i
 * verkstaden5-tool-data — samma källa som bygger verktygsdatabaserna för
 * Vectric och Fusion 360. Kalkylatorn kan därför inte visa andra siffror än
 * databaserna.
 *
 * Redigera inte värden här. Ändra i källan och kör om bygget.
 */
document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('mk-data');
  var maskinSelect = document.getElementById('mk-maskin');
  var materialSelect = document.getElementById('materialSelect');
  var sizeSelect = document.getElementById('sizeSelect');
  var flutesInput = document.getElementById('flutesInput');
  var rpmInput = document.getElementById('rpmInput');
  var resultEl = document.getElementById('result');
  if (!dataEl || !maskinSelect || !materialSelect || !sizeSelect || !flutesInput || !rpmInput || !resultEl) return;

  var warningEl = document.getElementById('warning');
  var hintEl = document.getElementById('mk-maskin-hint');
  var resetBtn = document.getElementById('mk-reset');

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    resultEl.textContent = 'Skärdatan kunde inte läsas.';
    return;
  }

  var LAGRING = 'v5-maskinprofil';
  var HOBBYTAK = 2500;

  function nf(v, d) {
    return v.toLocaleString('sv-SE', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function diaEtikett(d) {
    return (d === 3.175 ? '3' : String(d).replace('.', ',')) + ' mm';
  }
  function materialById(id) {
    for (var i = 0; i < data.material.length; i++) if (data.material[i].id === id) return data.material[i];
    return null;
  }

  /* ── maskinprofil ──────────────────────────────────────────────────── */

  Object.keys(data.profiler).forEach(function (id) {
    var o = document.createElement('option');
    o.value = id;
    o.textContent = data.profiler[id].namn;
    maskinSelect.appendChild(o);
  });
  var sparad = null;
  try { sparad = localStorage.getItem(LAGRING); } catch (e) { /* privat läge */ }
  maskinSelect.value = (sparad && data.profiler[sparad]) ? sparad : 'hobby';

  /* ── material ──────────────────────────────────────────────────────── */

  data.material.forEach(function (m) {
    var o = document.createElement('option');
    o.value = m.id;
    o.textContent = m.namn;
    materialSelect.appendChild(o);
  });

  function fyllDiametrar() {
    var m = materialById(materialSelect.value);
    var forra = sizeSelect.value;
    sizeSelect.innerHTML = '';
    if (!m) return;
    var ds = Object.keys(m.chipload).map(Number).sort(function (a, b) { return a - b; });
    ds.forEach(function (d) {
      var o = document.createElement('option');
      o.value = String(d);
      o.textContent = diaEtikett(d);
      sizeSelect.appendChild(o);
    });
    if (ds.map(String).indexOf(forra) !== -1) sizeSelect.value = forra;
    else if (ds.indexOf(6) !== -1) sizeSelect.value = '6';
  }

  /* ── beräkning ─────────────────────────────────────────────────────── */

  function rakna() {
    var m = materialById(materialSelect.value);
    var d = Number(sizeSelect.value);
    var z = Number(flutesInput.value);
    var rpm = Number(rpmInput.value);
    var profilId = maskinSelect.value;
    var profil = data.profiler[profilId];

    if (hintEl) hintEl.textContent = profil ? (profil.kort || profil.beskrivning) : '';

    if (!m || !d || !z || !rpm || z < 1 || rpm < 1) {
      resultEl.textContent = 'Välj material och diameter för att se rekommenderad matningshastighet.';
      if (warningEl) warningEl.textContent = '';
      return;
    }

    var band = m.chipload[String(d)];
    if (!band) {
      resultEl.textContent = 'Ingen data för den kombinationen.';
      if (warningEl) warningEl.textContent = '';
      return;
    }

    var chipLo = band[0], chipHi = band[1];
    var lo = chipLo * z * rpm, hi = chipHi * z * rpm;

    // Hobbyprofilen kapar matningen. Faller chiploaden under gnidningsgränsen
    // är det varvtalet som ska ner, inte chiploaden — samma ordning som i
    // verktygsdatabaserna.
    var kapad = false;
    if (profilId === 'hobby' && hi > HOBBYTAK) {
      kapad = true;
      hi = HOBBYTAK;
      chipHi = hi / (z * rpm);
      if (lo > HOBBYTAK) { lo = HOBBYTAK; chipLo = chipHi; }
    }

    var feedText = (Math.round(lo) === Math.round(hi))
      ? nf(Math.round(hi), 0) + ' mm/min'
      : nf(Math.round(lo), 0) + '–' + nf(Math.round(hi), 0) + ' mm/min';

    var chipText = (Math.abs(chipLo - chipHi) < 0.0005)
      ? nf(chipHi, 3) + ' mm/tand'
      : nf(chipLo, 3) + '–' + nf(chipHi, 3) + ' mm/tand';

    var html = '<span class="mk-result-feed">' + feedText + '</span>' +
      m.namn + ' · ' + diaEtikett(d) + ' · ' + z + ' skär · ' + nf(rpm, 0) + ' rpm';

    html += '<dl class="mk-result-rows">';
    html += '<dt>Chipload</dt><dd>' + chipText + '</dd>';
    html += '</dl>';

    resultEl.innerHTML = html;

    if (warningEl) {
      warningEl.textContent = kapad
        ? 'Matningen är kapad mot hobbymaskinens tak på 2 500 mm/min, vilket ger lägre chipload än optimalt. '
          + 'Klarar din maskin mer — byt till Industriell maskin. Behöver du ligga kvar: sänk varvtalet i '
          + 'stället för att låta fräsen gnugga.'
        : '';
    }

    visaProdukt(m);
  }

  /* ── produktrekommendation ─────────────────────────────────────────── */

  var PRODUKT = {
    'aluminium':  '1-skarig-dlc-fras-mjuka-metaller',
    'akryl':      'frasstal-for-frasning-i-plast',
    'hard-plast': 'frasstal-for-frasning-i-plast',
    'mjuk-plast': 'frasstal-for-frasning-i-plast',
    'hart-tra':   '2-skarig-uppatskarande-fras',
    'mjukt-tra':  'kompressionsfras',
    'mdf':        '2-skarig-uppatskarande-fras',
    'melamin':    'kompressionsfras',
    'fr4':        'pcb-fras'
  };

  var recEl = document.getElementById('mk-product-rec');
  var recWrap = document.getElementById('mk-product-card-wrap');
  var recNamn = document.getElementById('mk-rec-material');
  var aktivHandle = null;

  function doljProdukt() {
    if (!recEl) return;
    aktivHandle = null;
    recEl.style.opacity = '0';
    setTimeout(function () { recEl.style.display = 'none'; }, 280);
  }

  function kort(product) {
    var img = product.images[0] || {};
    var priser = product.variants.map(function (v) { return parseFloat(v.price); });
    var min = Math.min.apply(null, priser);
    var etikett = (product.variants.length > 1 ? 'Från ' : '') + Math.round(min) + ' kr';
    var url = '/products/' + product.handle;
    var bild = img.src ? img.src + (img.src.indexOf('?') !== -1 ? '&' : '?') + 'width=600' : '';

    return '<a href="' + url + '" style="display:block;text-decoration:none;color:#1a1a1a;border:1px solid #e0e4d2;border-radius:14px;overflow:hidden;background:#fff;">'
      + (bild ? '<img src="' + bild + '" alt="" loading="lazy" style="width:100%;aspect-ratio:1;object-fit:cover;display:block;">' : '')
      + '<div style="padding:18px;">'
      + '<p style="margin:0 0 4px;font-weight:600;line-height:1.35;">' + product.title + '</p>'
      + '<p style="margin:0 0 12px;color:#666;font-size:0.9rem;">' + etikett + '</p>'
      + '<span style="display:inline-block;padding:9px 18px;background:#8aa55c;color:#fff;font-size:0.85rem;font-weight:700;border-radius:6px;">Se frässtålet →</span>'
      + '</div></a>';
  }

  function visaProdukt(m) {
    if (!recEl || !recWrap || !recNamn) return;
    var handle = PRODUKT[m.id];
    if (!handle) { doljProdukt(); return; }
    if (handle === aktivHandle) return;
    aktivHandle = handle;
    recNamn.textContent = m.namn;

    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.product) { doljProdukt(); return; }
        recWrap.innerHTML = kort(d.product);
        recEl.style.display = '';
        requestAnimationFrame(function () { recEl.style.opacity = '1'; });
      })
      .catch(doljProdukt);
  }

  /* ── händelser ─────────────────────────────────────────────────────── */

  maskinSelect.addEventListener('change', function () {
    try { localStorage.setItem(LAGRING, maskinSelect.value); } catch (e) { /* privat läge */ }
    rakna();
  });
  materialSelect.addEventListener('change', function () { fyllDiametrar(); rakna(); });
  sizeSelect.addEventListener('change', rakna);
  flutesInput.addEventListener('input', rakna);
  rpmInput.addEventListener('input', rakna);

  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      materialSelect.selectedIndex = 0;
      flutesInput.value = '2';
      rpmInput.value = '10000';
      fyllDiametrar();
      rakna();
    });
  }

  fyllDiametrar();
  rakna();
});
